import { ICategory } from '@shared/types.ts';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDebounce } from '@uidotdev/usehooks';
import { useSubcategories } from '../subcategories';
import { useProducts } from '../product';
import { Button, Divider } from '@heroui/react';
import { PriceRangeInput } from '@ui/product/price-range-input.ui.tsx';
import { ManufacturerPicker } from '@ui/product/manufacturer-picker.tsx';
import { ProductsGrid } from '@ui/product/products-grid.tsx';

export const DesktopCategoryDashboard = ({
  categoryId,
  subcategoryId,
  onSelectCategory,
}: {
  categoryId: number;
  subcategoryId?: number;
  onSelectCategory?: (value: ICategory) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isShowAll, setIsShowAll] = useState<boolean>(false);
  const [from, setFrom] = useState<string | undefined>();
  const [to, setTo] = useState<string | undefined>();

  const fromDebounce = useDebounce(from, 800);
  const toDebounce = useDebounce(to, 800);

  const { rawData: subcategories } = useSubcategories({ categoryId });

  const { data } = useProducts({
    categoryIds: subcategoryId ? [categoryId, subcategoryId] : [categoryId],
    searchParams,
  });
  console.log(data);

  useEffect(() => {
    if (from) {
      searchParams.set('price_from', from);
    } else {
      searchParams.delete('price_from');
    }
    if (to) {
      searchParams.set('price_to', to);
    } else {
      searchParams.delete('price_to');
    }
    setSearchParams(searchParams);
  }, [fromDebounce, toDebounce]);

  const list =
    subcategories && subcategories[0].children ? subcategories[0].children : [];

  return (
    <div className="flex flex-row pb-80 mt-12 gap-x-9">
      <div className="w-[290px]">
        <div className="flex flex-col">
          <p className="text-[#222222] font-semibold">Все подкатегории</p>
          <Divider className="mt-3 mb-4" />
          {list
            .slice(0, isShowAll ? list.length : 6)
            .map((subcategory, index) => (
              <Button
                key={index}
                color="primary"
                variant={subcategoryId === subcategory.id ? 'flat' : 'light'}
                fullWidth
                className="text-[#222222] justify-start text-base"
                onPress={() => onSelectCategory?.(subcategory)}
              >
                {subcategory.name}
              </Button>
            ))}

          {list.length > 6 && (
            <div className="mt-2">
              <Button
                color="primary"
                size="sm"
                variant="light"
                className="justify-start font-semibold text-base"
                onPress={() => setIsShowAll(true)}
              >
                Показать все
              </Button>
            </div>
          )}

          <div className="mt-9">
            <PriceRangeInput
              from={from}
              onChangeFrom={setFrom}
              to={to}
              onChangeTo={setTo}
            />
          </div>

          <div className="mt-9">
            <ManufacturerPicker />
          </div>
        </div>
      </div>
      <div className="flex-grow">
        <ProductsGrid className="lg:grid-cols-3" items={data} />
      </div>
    </div>
  );
};
